import Modal from "react-modal"
import clsx from "clsx"
import { useCallback, useContext } from "react"
import { globalStoreContext } from "src/store/GlobalStore"
import Link from "next/link"
import routes from "routes"

const RegisterDialog: React.FC = () => {
  const {
    globalDispatch,
    globalStore: {
      ui: {
        modal: { registerDialog },
      },
    },
  } = useContext(globalStoreContext)

  const onClose = useCallback(() => {
    globalDispatch({ type: "ui/modal/registerDialog", payload: false })
  }, [globalDispatch])

  return (
    <Modal
      isOpen={registerDialog}
      className="p-modal"
      overlayClassName={clsx({
        "p-modal-overlay": true,
        "is-show": true,
      })}
    >
      <div className="p-modal-wrapper">
        <div className="p-modal-contents-inner">
          <div className="p-modal-header">
            <p className="p-modal-title">どちらを登録しますか？</p>
            <button
              className="c-close-button p-modal-close js-modal-close"
              onClick={onClose}
            >
              <span className="c-close-button-icon"></span>
              <span className="c-close-button-label">閉じる</span>
            </button>
          </div>

          <div className="modal-creatorSearch">
            <div>
              <Link href={routes.creatorMyPageNovelsCreateNovel()}>
                <a
                  className="c-button-secondary -full"
                  onClick={() => {
                    onClose()
                  }}
                >
                  小説を登録する
                </a>
              </Link>
            </div>
            <div className="u-mt-15">
              <Link href={routes.creatorMyPageIllustrationNew()}>
                <a
                  className="c-button-secondary -full"
                  onClick={() => {
                    onClose()
                  }}
                >
                  イラストを登録する
                </a>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default RegisterDialog
